module.exports = __webpack_public_path__ + "static/img/coupon.57db6a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/coupon.png
// module id = UEmW
// module chunks = 0